import { H5, H6, Separator } from '@fs/zion-ui'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { usePageTitle } from '../app/PageTitleContext'
import ArtifactCard from './ArtifactCard'
import ArtifactCardGrid from './ArtifactCardGrid'
import useEscalatedArtifacts from '../../hooks/artifacts/useEscalatedArtifacts'
import SelectedArtifactsActions from './SelectedArtifactsActions'

export default function EscalatedArtifacts() {
  usePageView({ page_detail: 'DMConsole:EscalatedArtifacts' })
  const [t] = useTranslation()
  usePageTitle(t('pageTitle.artifacts.escalated'))
  const { artifacts, totalArtifacts, setRefetch } = useEscalatedArtifacts()
  const [checkedArtifacts, setCheckedArtifacts] = useState([])
  const [selectAllArtifacts, setSelectAllArtifacts] = useState(false)

  const refetchArtifacts = () => setRefetch((prevState) => !prevState)

  const onCheckboxChange = (artifactId, checked) => {
    setCheckedArtifacts((prev) => {
      if (checked) {
        return [...prev, artifactId]
      }
      return prev.filter((aId) => aId !== artifactId)
    })
  }

  if (!artifacts) {
    return null
  }
  if (artifacts.length === 0) {
    return <H5 supplementary>{t('artifacts.noArtifactsFound', 'No artifacts found')}</H5>
  }

  return (
    <>
      {artifacts && (
        <>
          <H6>
            {artifacts.length > 0
              ? t('artifacts.escalatedArtifactsFound_plural', `${totalArtifacts} escalated artifacts found`, {
                  count: totalArtifacts,
                })
              : t('artifacts.noEscalatedArtifactsFound', 'No escalated artifacts found')}
          </H6>
          <Separator size="sm" />
        </>
      )}
      {artifacts && artifacts.length > 0 && (
        <>
          <SelectedArtifactsActions
            artifacts={artifacts}
            checkedArtifacts={checkedArtifacts}
            setCheckedArtifacts={setCheckedArtifacts}
            refetch={refetchArtifacts}
            selectAllArtifacts={selectAllArtifacts}
            setSelectAllArtifacts={setSelectAllArtifacts}
          />
          <Separator size="sm" />
        </>
      )}
      <ArtifactCardGrid>
        {artifacts.map((artifact) => {
          return artifact.first ? (
            <ArtifactCard
              key={artifact.id}
              artifact={artifact}
              refetchArtifacts={refetchArtifacts}
              selectable
              checked={checkedArtifacts.includes(artifact.id)}
              onCheckboxChange={onCheckboxChange}
            />
          ) : null
        })}
      </ArtifactCardGrid>
    </>
  )
}
